import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { PDFHeader } from "../../../../../global/globalFunctions";
import { UpdateAreaApi, DeleteAreaApi } from "./areaAction";
import MaterialSize from "material-table";
import jsPDF from 'jspdf';
import 'jspdf-autotable';


const ViewArea = (props) => {
  // const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  // const Checkpermissions = (permissionsType, permissionsName) => {
  //   return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
  // };

  useEffect(() => {
    props.setHeading("View Area");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialSize
          title="View Area"
          columns={[
            { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
            { title: 'Area Name', field: 'areaName' },
            { title: 'Area Location', field: 'location' },
            { title: 'Description', field: 'areaDesc' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/area/get-areas?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
              whiteSpace: 'nowrap',
            },
            rowStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "potrait";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Area Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((elt) => [
                elt.sequenceNumber,
                elt.areaName,
                elt.location,
                elt.areaDesc,
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Area Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          editable={{
            // isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Area Edit"),
            // isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Area Delete"),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.UpdateAreaApi(newData, oldData);
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.DeleteAreaApi(oldData._id);
                }, 600);
              }),
          }}
        />
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    UpdateAreaApi: (newData, oldData) => dispatch(UpdateAreaApi(newData, oldData)),
    DeleteAreaApi: (areaId) => dispatch(DeleteAreaApi(areaId)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ViewArea);